module.exports = __webpack_public_path__ + "img/arrowLeft.4f65966a.svg";